import axios from 'axios';
import router from '@/router';

export default function jwtInterceptor() {
    axios.interceptors.request.use(function (config) {
        const token = localStorage.getItem('jwtToken');
        const url = config.url;
        if (url && url.indexOf('mobile-users/auth') == -1) {
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
        }
        return config;
    }, function (err) {
        return Promise.reject(err);
    });

    axios.interceptors.response.use(function (response) {
        return response
    }, function (err) {
        if (err.response.status === 401) {
            router.push('/login')
        }
        
        err.response.data.message = 'System Error!';
        return Promise.reject(err.response.data)
    })
}